
import {exampleClient} from "../server/examples/client.js"

console.log("renraku")
await exampleClient()

